import { MascotCareCheckout } from './MascotCareCheckout'

export function MascotEnergyPill(props: {
  campaignId: number
  energy: number
  disabled: boolean
  onPaid: () => Promise<void>
}) {
  return <MascotCareCheckout {...props} />
}
